import TVdxbDefaultEntrySidebar from './index.vue';

TVdxbDefaultEntrySidebar.install = app => {
  app.component(TVdxbDefaultEntrySidebar.name, TVdxbDefaultEntrySidebar);
};

export default TVdxbDefaultEntrySidebar;
